module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAT9JREFUOE+9k7FOAkEQhr8JiomNFjZgfIGz1AYLnwCNiT4C9EhhZRQIdoaj0UJewcpIi/RSW4oVQqOGwhCJN2ajp7dyCsXpdjO7+80/s/8KES2JiEMoKJnTjAq1n4qoku5WpR7cHwEt5jTlCU0g/ova9swczl1BBv4ZC7SQ08QUtERIjmtZlUK3KsURkHOo8cc+V8DaOMjH/sCL4fSOpW3iT0WJXT0Dsj5kOgYHm7C9AiJw3oLSBQxfv8oI1DuupL+DNKiktAWZdVvbSQOOLu3cvWvK2Ios0E0Z5mftS0/P4Oz/GyivNZSMXy+stdMGlAOthc7IvNpDn6ZAysD8Ye+svqNDhj3wYLnnyq01IxMs7Wly+ML1JD4SodipSCHUkCYZibN9eiKvWRTjq9DlCRu9ilhG+NvfP+EXsY5FpugN6XJwE/WcUD8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/actSetNav.png
// module id = 0XLk
// module chunks = 95